"use client";

import { useCallback } from "react";
import Link from "next/link";

// FIXME... have auth token

interface Props {
    serverId?: string;
    createServerAction?: () => Promise<void>;
}

const Server = ({ serverId, createServerAction }: Readonly<Props>) => {
    const action = useCallback(async () => {
        await createServerAction?.();
    }, [createServerAction]);
    return <form action={action}>
        <h1>Server</h1>
        <div>
            <button>Create Server Id</button>
        </div>
        <div>
        {
            serverId && <Link href={`/server/${serverId}`}>You are server {serverId}</Link>
        }
        </div>
        </form>;
};

export default Server;
